<template>
  <div id="selefie-dicas">
    <p class="txt-titulo">Temos dicas pra te ajudar a tirar a foto (selfie)</p>
    <div class="dicas">
      <div class="row">
        <div class="col-2">
          <img class="img-fluid mx-auto"
               src="@/assets/img/dicas-selfie/acessorios.png"
               title="Seu rosto precisa estar visível na foto"
               alt="Seu rosto precisa estar visível na foto">
        </div>
        <div class="col-10">
          <p class="txt-subtitulo">Seu rosto precisa estar visível na foto</p>
          <p class="txt-padrao">Evite usar máscara, boné, óculos escuros ou qualquer acessório</p>
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <img class="img-fluid mx-auto"
               src="@/assets/img/dicas-selfie/lampada.png"
               title="Fique num lugar com boa iluminação"
               alt="Fique num lugar com boa iluminação">
        </div>
        <div class="col-10">
          <p class="txt-subtitulo">Fique num lugar com boa iluminação</p>
          <p class="txt-padrao">Procure um espaço claro, sem objetos ou pessoas ao fundo</p>
        </div>
      </div>
      <div class="row">
        <div class="col-2">
          <img class="img-fluid mx-auto"
               src="@/assets/img/dicas-selfie/centralizar.png"
               title="Centralize seu rosto na moldura"
               alt="Centralize seu rosto na moldura">
        </div>
        <div class="col-10">
          <p class="txt-subtitulo">Centralize seu rosto na moldura</p>
          <p class="txt-padrao">Coloque o rosto dentro da moldura e siga as instruções da tela</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DicasSelfie"
}
</script>

<style scoped>
.dicas{
  margin-top: 3rem;
}
.dicas .row .col-2{
  padding-right: 0;
}
.dicas p{
  margin: 0;
}
.dicas p.txt-subtitulo{
  line-height: normal;
}
.dicas .row{
  margin-bottom: 2rem;
  padding-bottom: 0.5rem;
}
.dicas .row:nth-child(-n + 2){
  border-bottom: solid 1px #cccc;
}

@media (max-device-height: 639px),(max-height: 575px){
  .dicas{
    margin-top: 1.3rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/shared/DicasSelfie.vue